import React, { Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Tip } from "../../../lib";
import { CircularLoader } from "../../../lib/ui/Progress";
import { eventEmitter, i18n } from "../../../services";

import { THEME_LOW } from "../../../reducers/reader";
import Back from "./Back";
import Download from "./Download";
import FontSize from "./FontSize";
import Theme from "./Theme";
import Share from "./Share";
import { ReaderDoc } from "../PageContents/index";
import { AppState } from "../../../store";
import { KEY_L, KEY_S, KEY_Y } from "../../../lib/keyboard/keys";

const Container = styled.div`
    position: fixed;
    z-index: 30;
    bottom: 2vh;
    right: 1.75vw;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    > div {
        cursor: pointer;
        margin-bottom: 13px;
    }

    > div:last-of-type {
        margin-bottom: 0;
    }

    img {
        max-width: unset;
    }

    @media (max-width: 1024px) {
        right: 1.25vw;
    }

    @media (max-width: 800px) {
        display: none;
    }
`;

const mapState = ({ reader }: AppState) => ({
    //@ts-ignore
    theme: reader.get("theme") as string,
});
type StateProps = ReturnType<typeof mapState>;
type OwnProps = {
    theme: string;
    doc: ReaderDoc;
    page_id: number;
};
type Props = StateProps & OwnProps;
type State = {
    processingPDF: boolean;
};

class Tools extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            processingPDF: false,
        };
    }

    componentDidMount() {
        eventEmitter.on("pdf.processing", this.onPDFProcessing);
    }

    componentWillUnmount() {
        eventEmitter.off("pdf.processing", this.onPDFProcessing);
    }

    onPDFProcessing = (processingPDF: boolean) =>
        this.setState({ processingPDF });

    downloadBtn() {
        const { doc, theme } = this.props;
        const { processingPDF } = this.state;
        if (typeof doc === "undefined" || doc.skip_pdf) {
            return null;
        }

        const darkTheme = theme === THEME_LOW;
        return (
            <Fragment>
                {!processingPDF && (
                    <Tip anchor="left-top" text={i18n.get("tip.download")}>
                        <Download doc={doc} isDark={darkTheme} />
                    </Tip>
                )}

                {processingPDF && (
                    <CircularLoader
                        margin="-2px 0 0 0"
                        border="2px"
                        width="22px"
                        height="22px"
                    />
                )}
            </Fragment>
        );
    }

    render() {
        const { doc, theme } = this.props;
        const darkTheme = theme === THEME_LOW;

        return (
            <Container>
                <Tip anchor="left-top" text={i18n.get("tip.share")} ltr={KEY_Y}>
                    <Share
                        doc={doc}
                        isDark={darkTheme}
                        page_id={this.props.page_id}
                    />
                </Tip>

                <Tip anchor="left-top" text={i18n.get("tip.size")} ltr={KEY_S}>
                    <FontSize isDark={darkTheme} />
                </Tip>

                <Tip anchor="left-top" text={i18n.get("tip.theme")} ltr={KEY_L}>
                    <Theme isDark={darkTheme} />
                </Tip>

                <Tip anchor="left-top" text={i18n.get("tip.return")}>
                    <Back doc={doc} isDark={darkTheme} />
                </Tip>
                {this.downloadBtn()}
            </Container>
        );
    }
}

export default connect(mapState)(Tools);
